<template>
	<div class="w-full h-full absolute inset-0 bg-black text-white flex flex-col p-6 space-y-6">
		<div class="w-full flex justify-between items-center">
			<div>Untitled session</div>
			<div class="flex items-center space-x-4">
				<div>Copy invite link</div>
				<div>Connected</div>
			</div>
		</div>

		<div class="w-full grow flex space-x-6 h-full transition-all duration-150 ease-in-out overflow-hidden">
			<div :class="[sidePanels.find(el => el.active) ? 'w-[calc(100%-25rem-(6*4px))]' : 'w-full', 'transition-[width] duration-150 ease-in-out origin-left transition-transform duration-150 ease-in-out h-full flex space-x-6 transition-all transition-all duration-150 ease-in-out']">
				<div class="flex space-x-6 h-full w-full">

					<template v-if="!participants">
						<div class="bg-[#1C1C1E] w-full h-full rounded-2xl overflow-hidden transform-gpu">
							<div class="relative w-full h-full flex items-center justify-center">
								<div class="absolute z-20 w-[20vw] h-[20vw] rounded-full bg-gray-300 bg-center bg-cover flex items-center justify-center text-[5vw] text-gray-600 font-medium" :style="'background-image: url(' + user?.avatar + ')'">
									<span v-if="!user?.avatar">{{ user?.name.charAt(0).toUpperCase() }}{{ user?.name.charAt(1) }}</span>
								</div>
								<div class="absolute z-10 w-[20vw] h-[20vw] bg-gradient-to-br from-regal-blue-700 to-purple-400 rounded-full transform-gpu" :style="'transform: scale(' + volume + ')'"></div>
							</div>
							<!-- <video class="w-full h-full object-cover -scale-x-[1]" autoplay ref="localVideo" /> -->
						</div>
					</template>

					<template v-if="participants">
						<template v-for="p in participants" :key="p.session_id">
							<ParticipantTile :participant="p" />
						</template>
					</template>
				</div>
			</div>
		</div>

		<Transition mode="out-in" enter-from-class="translate-x-[25rem]" enter-to-class="translate-x-0" leave-from-class="translate-x-0" leave-to-class="translate-x-[25rem]">
			<div v-if="sidePanels.find(el => el.active)" class="transition-transform duration-150 ease-in-out absolute right-6 top-0 w-[25rem] shrink-0 h-full max-h-[calc(100vh-8rem)] text-black bg-white rounded-2xl px-8 py-6 overflow-scroll hide-scroll-bar">
				<div v-for="recording in recordings">
					<input type="text" v-model="recording.title">
				</div>
				<div v-if="showTemplateSelect" class="grid grid-cols-3 gap-3 mt-16">
					<div class="w-full aspect-w-1 aspect-h-1 rounded-lg cursor-pointer group">
						<div class="w-full h-full flex items-center justify-center flex-col">
							<div class="group-hover:brightness-95 group-hover:saturate-[1.25] grow w-full bg-gray-200 rounded-lg text-gray-600 flex items-center justify-center">
								<PlusIcon class="w-8 h-8" />
							</div>
							<div class="text-sm font-medium py-2">Blank</div>
						</div>
					</div>
					<template v-for="template in templates">
						<div @click="selectTemplate(template)" class="w-full aspect-w-1 aspect-h-1 rounded-xl cursor-pointer group">
							<div class="w-full h-full flex items-center justify-center flex-col">
								<div :class="'group-hover:brightness-95 group-hover:saturate-[1.25] grow w-full rounded-lg flex items-center justify-center ' + template.bgColor + ' ' + template.color">
									<component :is="template.icon" class="w-8 h-8" />
								</div>
								<div class="text-sm font-medium py-2">{{ template.name }}</div>
							</div>
						</div>
					</template>
				</div>

				<div v-else class="">
					<template v-for="script in templates">
						<template v-if="script.active">
							<div class="flex justify-between w-full space-x-2 py-[0.25rem]">
<!-- 								<div>
									<div class="text-lg text-gray-600 flex items-center group-hover:opacity-100 opacity-0 transition-opacity duration-150 ease-in-out">
										<div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"> <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /> </svg></div>
										<div class="text-xl">⠿</div>
									</div>
								</div> -->
								<div class="flex-1">
									<div class="flex space-x-2">
										<div contenteditable class="focus:outline-0 -tracking-[0.01rem] grow leading-tighter text-3xl font-bold mb-7">{{ script.title }}</div>
									</div>
								</div>
							</div>
							<template v-for="content in script.content">
								<div class="flex w-full space-x-2 group py-[0.35rem]">
<!-- 									<div>
										<div class="text-lg text-gray-600 flex items-center group-hover:opacity-100 opacity-0 transition-opacity duration-150 ease-in-out">
											<div><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5"> <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" /> </svg></div>
											<div class="text-xl">⠿</div>
										</div>
									</div> -->
									<div class="flex space-x-2">
										<div @click="content.selected = !content.selected" :class="[content.selected ? 'bg-regal-blue-600 text-white' : 'border-[1.5px] border-regal-blue-900 hover:bg-gray-400', 'rounded-sm w-4 h-4 flex items-center justify-center mt-1 shrink-0 cursor-pointer']">
											<CheckIcon v-if="content.selected" class="w-4 h-4" />
										</div>
										<div contenteditable :class="[content.selected ? 'text-gray-700' : '', 'focus:outline-0 -tracking-[0.005rem] grow leading-tighter']" :style="content.selected ? 'text-decoration-line: line-through;' : ''">{{ content.text }}</div>
									</div>
								</div>
							</template>
						</template>
					</template>
				</div>
				<div class="shrink-0 absolute right-4 top-5 flex space-x-2 pt-6">
					<div v-if="!showTemplateSelect" class="border border-gray-400 cursor-pointer shink-0 w-12 h-12 flex items-center justify-center rounded-full">
						<UploadIcon class="w-5 h-5" />
					</div>
					<div v-if="!showTemplateSelect" @click="showTemplateSelect = true" class="border border-gray-400 cursor-pointer shink-0 w-12 h-12 flex items-center justify-center rounded-full">
						<CollectionIcon class="w-5 h-5" />
					</div>
					<div v-else @click="showTemplateSelect = false" class="border border-gray-400 cursor-pointer shink-0 w-12 h-12 flex items-center justify-center rounded-full">
						<XIcon class="w-5 h-5" />
					</div>
				</div>
			</div>
		</Transition>

		<div class="w-full flex items-center justify-between">
			<div class="w-[25rem] flex items-center"></div>
			<div class="flex space-x-2.5 items-center">
				<div @click="toggleRecording" :class="[recording ? 'bg-white text-regal-blue-900' : 'bg-red-500 hover:bg-red-600', 'w-32 h-14 rounded-2xl cursor-pointer text-white flex space-x-2.5 items-center justify-center group']">
					<div class="flex items-center justify-center space-x-2.5 w-20">
						<div class="w-3 h-3 relative shrink-0">
							<div v-if="!recording" class="absolute w-3 h-3 bg-red-100 rounded-full group-hover:bg-white"></div>
							<template v-else>
								<div v-if="recording" class="absolute w-3 h-3 bg-red-500 rounded-full"></div>
								<div v-if="recording" class="absolute w-3 h-3 bg-red-500 animate-ping rounded-full"></div>
							</template>
						</div>
						<div :class="[recording ? '' : 'group-hover:text-white', 'text-sm font-semibold grow flex items-center justify-center']">
							<span v-if="!recording">Record</span>
							<template v-else>
								<span class="tabular-nums text-regal-blue-900/[0.77] group-hover:hidden">{{ timeRecorded }}</span>
								<span class="hidden group-hover:block">Stop</span>
							</template>
						</div>
					</div>
				</div>
				<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-[#8D8E93] hover:bg-[#242426] cursor-pointer hover:text-white">
					<MicrophoneIcon class="w-5 h-5" />
				</div>
				<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-[#8D8E93] hover:bg-[#242426] cursor-pointer hover:text-white">
					<VideoCameraIcon class="w-5 h-5" />
				</div>
				<div class="w-14 h-14 rounded-2xl bg-[#1C1C1E] flex items-center justify-center text-red-600 hover:bg-[#242426] cursor-pointer hover:text-red-500">
					<XIcon class="w-5 h-5" />
				</div>
			</div>
			<div class="w-[25rem] flex items-center justify-end">
				<template v-for="tab in sidePanels">
					<div @click="toggleSidepanel(tab)" class="w-14 h-14 rounded-2xl flex items-center justify-center text-red-600 cursor-pointer text-[#8D8E93] hover:text-white">
						<component :is="tab.icon" class="w-6 h-6" />
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps } from 'vue'
import daily from '@daily-co/daily-js'
import { usePage } from '@inertiajs/inertia-vue3'
import axios from 'axios'
import { MediaPermissionsError, MediaPermissionsErrorType, requestMediaPermissions } from 'mic-check'
import ParticipantTile from '@/Pages/Recordings/ParticipantTile'
import { Inertia } from '@inertiajs/inertia'
import { CurrencyDollarIcon, PlusIcon, CollectionIcon, XIcon, CheckIcon, UploadIcon, MicrophoneIcon, VideoCameraIcon, DocumentTextIcon, PlayIcon } from '@heroicons/vue/outline'
import Timer from 'easytimer.js'

const sidePanels = ref([
	{
		name: 'Notes',
		// component: SidebarNotes,
		icon: DocumentTextIcon,
		active: false,
	},
	{
		name: 'Recordings',
		// component: SidebarNotes,
		icon: PlayIcon,
		active: false,
	}
])

const toggleSidepanel = (selectedSidePanel) => {
	sidePanels.value.forEach(sidePanel => {
		if (sidePanel.name = selectedSidePanel.name) {
			sidePanel.active = !sidePanel.active
		} else {
			sidePanel.active = false
		}
	})
}

const showTemplateSelect = ref(false)

const templates = ref([
	{
		name: 'Basic outline',
		title: 'My basic podcast script',
		description: 'A simple road map for where you’re headed and what you want to touch on without scripting things out.',
		active: true,
		bgColor: 'bg-orange-100',
		color: 'text-orange-600',
		icon: DocumentTextIcon,
		content: [
			{
				type: 'to_do',
				selected: false,
				text: 'Show intro (who you are, what you’re going to talk about): 30-60 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Intro music (repeat for each show so listeners identify the jingle with your show): 30-60 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Topic 1: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Topic 2: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Interlude (music or break): 30 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Topic 3: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Topic 4: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Closing remarks (thank audience, thank guests, talk about the next show): 2 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Closing music (suggest same as Intro music jingle): 30-60 seconds'
			},
		]
	},
	{
		name: 'Rags-to-Riches',
		title: 'How you went from difficult circumstances to great success',
		description: 'Use this template to show how you or your guest are able to use your vulnerabilites to achieve results at work. Tell a story about overcoming early struggles through taking risks and explain how you grew as a result.',
		active: false,
		bgColor: 'bg-lime-100',
		color: 'text-lime-600',
		icon: CurrencyDollarIcon,
		content: [
			{
				type: 'to_do',
				selected: false,
				text: 'Show intro (what this is about and why someone should care listening): 30-60 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Intro music (repeat for each show so listeners identify the jingle with your show): 30-60 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 1: Terrible early life: 2 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 2: Receives call to leave: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Interlude (upbeat music or break): 30 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 3: Minor struggles and small successes: 2 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 4: Hits rock bottom: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Interlude (dark music or break): 30 seconds'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 5: Defeat the crisis: 5 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Plot point 6: Wins and gets reward: 3 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Closing remarks (thank audience, thank guests, talk about the next show): 2 minutes'
			},
			{
				type: 'to_do',
				selected: false,
				text: 'Closing music (suggest same as Intro music jingle): 30-60 seconds'
			},
		]
	}
])

const selectTemplate = (selectedTemplate) => {
	templates.value.forEach(el => {
		if (selectedTemplate.name == el.name) {
			el.active = true
		} else {
			el.active = false
		}
	})
	showTemplateSelect.value = false
}

const loading = ref(true)
const error = ref(null)
const showPermissionsError = ref(false)
const participants = ref(null)
const callObject = ref(null)
const p = ref(null)
const count = ref(null)
const recording = ref(false)
const timer = ref(null)
const timeRecorded = ref('00:00.0')
const recordings = ref([])
const roomName = ref(null)
const audioDevices = ref([])
const videoDevices = ref([])
const localVideo = ref(null)
const user = computed(() => usePage().props.value.auth.user)
const volume = ref(0)
const recordedChunks = ref([])
const mediaRecorder = ref(null)

const props = defineProps(['room'])

const constraints = ref({
	audio: {
		echoCancellationType: 'system',
		echoCancellation: true,
		noiseSuppression: true,
		sampleRate:24000,
		sampleSize:16,
		channelCount:2,
	},
	video: false
})

const micCheck = () => {
	requestMediaPermissions()
	.then((e) => {
		setupDeviceList()

		navigator.mediaDevices
		.getUserMedia(constraints.value)
		.then((stream) => {
			setupMediaRecorder(stream)
			getVolume(stream)
			// if (window.URL) {
			// 	localVideo.value.srcObject = stream
			// } else {
			// 	localVideo.value.src = stream
			// }
		})

		loading.value = false
		// joinRoom({userName: 'Simon', name: props.room.uuid})
	})
	.catch((MediaPermissionsError) => {
		loading.value = false
		const { type, name, message } = MediaPermissionsError
		if (type === MediaPermissionsErrorType.SystemPermissionDenied) {
			// browser does not have permission to access camera or microphone
			showPermissionsError.value = true
		} else if (type === MediaPermissionsErrorType.UserPermissionDenied) {
			// user didn't allow app to access camera or microphone
			showPermissionsError.value = true
		} else if (type === MediaPermissionsErrorType.CouldNotStartVideoSource) {
			// camera is in use by another application (Zoom, Skype) or browser tab (Google Meet, Messenger Video)
			showPermissionsError.value = true
			// (mostly Windows specific problem)
		} else {
			// not all error types are handled by this library
			showPermissionsError.value = true
		}
	})
}

micCheck()

const map = (value, x1, y1, x2, y2) => (value - x1) * (y2 - x2) / (y1 - x1) + x2

const getVolume = (stream) => {
	const audioContext = new AudioContext()
	const analyser = audioContext.createAnalyser()
	const audioSource = audioContext.createMediaStreamSource(stream)

    analyser.fftSize = 512
    analyser.minDecibels = -105
    analyser.maxDecibels = 0
    analyser.smoothingTimeConstant = 0.7
    audioSource.connect(analyser)
    const volumes = new Uint8Array(analyser.frequencyBinCount)

    const volumeCallback = () => {
    	analyser.getByteFrequencyData(volumes)
    	let volumeSum = 0
    	for(const volume of volumes)
    		volumeSum += volume
    	const averageVolume = volumeSum / volumes.length
    	volume.value = map(Math.pow(averageVolume, 1.1), 0, 100, 1, 2)
    	window.requestAnimationFrame(volumeCallback)
    }
    volumeCallback()
	// const scriptProcessor = audioContext.createScriptProcessor(2048, 1, 1)

	// analyser.smoothingTimeConstant = 0.8
	// analyser.fftSize = 1024

	// microphone.connect(analyser)
	// analyser.connect(scriptProcessor)
	// scriptProcessor.connect(audioContext.destination)
	// scriptProcessor.onaudioprocess = () => {
	// 	const array = new Uint8Array(analyser.frequencyBinCount)
	// 	analyser.getByteFrequencyData(array)
	// 	const arraySum = array.reduce((a, value) => a + value, 0)
	// 	const average = arraySum / array.length
	// 	volume.value = map(average, 0, 100, 1, 2)
	// }
}

const setupDeviceList = () => {
	navigator.mediaDevices.enumerateDevices().then((devices) => {
		audioDevices.value = devices.filter((d) => d.kind === 'audioinput')
		videoDevices.value = devices.filter((d) => d.kind === 'videoinput')
	})
}

const joinRoom = async ({ userName, name }) => {
    let roomInfo = { name }

    if (!name) {
      roomInfo = await createRoom()
    }

    const options = {
      url: 'https://pager.daily.co/' + roomInfo?.name,
      userName: userName,
    }

    if (!name) {
	    let newToken = await createToken(roomInfo?.name, userName)
	    options.token = newToken?.token
    }

    const call = daily.createCallObject({
        audioSource: true,
        videoSource: true,
        dailyConfig: {
            experimentalChromeVideoMuteLightOff: true,
        },
    })

    callObject.value = call

    call
        .join(options)
        .then((e) => {
        		roomName.value = roomInfo.name
        	})
        .catch((err) => { throw new Error(err) })

	await call.on('joining-meeting', handleJoiningMeeting)
		.on('joined-meeting', updateParticpants)
		.on('participant-joined', updateParticpants)
		.on('participant-updated', updateParticpants)
		.on('participant-left', updateParticpants)
		.on('error', handleError)
		.on('camera-error', handleDeviceError)
		.on('app-message', updateMessages)
		.on('recording-started', handleRecordingStarted)
		.on('recording-stopped', handleRecordingStopped)
}

const createRoom = async (local = false) => {
    const response = await axios.post(route('rooms.store', {local: local}))
    const result = await response.data
    return result
}

const createToken = async (roomName, userName) => {
    const response = await axios.post(route('recordings.createToken', {'room_name': roomName, 'user_name': userName }))
    const result = await response.data
    return result
}

const handleJoiningMeeting = async () => {

}

const updateParticpants = () => {
	if (!callObject.value) return

	p.value = callObject.value.participants()
	count.value = Object.values(p.value).length
	participants.value = Object.values(p.value)

	loading.value = false
}

const handleError = async () => {

}

const handleDeviceError = async () => {

}

const updateMessages = async () => {

}

const handleRecordingStarted = async (e) => {
	await axios.post(route('recordings.store', {'room_name': roomName.value})).then((res) => {
		recordings.value.push(res.data)
	})
    recording.value = true
    startTimer()
}

const handleRecordingStopped = async () => {
	recording.value = false
    stopTimer()
    await axios.patch(route('recordings.update', { recording: recordings.value[recordings.value.length - 1].uuid}))
        .then((res) => {
        	console.log(res)
        })
}

const setupMediaRecorder = (stream) => {
	var options = {mimeType: 'audio/webm'}
	mediaRecorder.value = new MediaRecorder(stream, options)
	mediaRecorder.value.ondataavailable = handleDataAvailable
	mediaRecorder.value.onstart = handleLocalRecordingStarted
	mediaRecorder.value.onstop = handleLocalRecordingStopped
}

const toggleRecording = async () => {
	if (!recording.value) {
		if (!callObject.value) {
			mediaRecorder.value.start()
		} else {
			await callObject.value.startRecording()
		}
	} else {
		if (!callObject.value) {
			mediaRecorder.value.stop()
		} else {
			await callObject.value.stopRecording()
		}
	}
}

const handleLocalRecordingStarted = async () => {
	recordings.value.push({
		startedAt: Math.floor(Date.now() / 1000),
		title: 'Untitled recording',
		uuid: null,
		progress: null,
		duration: null,
		s3key: null,
	})
	startTimer()
	recording.value = true
}

const handleLocalRecordingStopped = async () => {
	var blob = new Blob(recordedChunks.value, {
		type: 'audio/webm'
	})

	var file = new File([blob], Math.floor(Date.now() / 1000) + '-' + user.uuid, {
		lastModified: new Date().getTime(),
		type: blob.type
	})

    const response = await Vapor.store(file, {
        progress: progress => {
        }
    })

    let currentRecording = recordings.value[recordings.value.length - 1]
    currentRecording['s3key'] = response.key

	await axios.post(route('recordings.store', {recording: currentRecording})).then((res) => {
		console.log(res)
	})

	resetTimer()
	recording.value = false
}

const handleDataAvailable = (event) => {
    if (event.data.size > 0) {
    	startTimer()
    	recording.value = true
    	recordedChunks.value.push(event.data)
    }
}

const startTimer = () => {
    timer.value = new Timer()
    timer.value.start({ precision: 'secondTenths', target: {seconds: 1800} })
    timer.value.addEventListener('secondTenthsUpdated', (e) => {
        timeRecorded.value = timer.value.getTimeValues().toString(['minutes', 'seconds', 'secondTenths'])
    })
    timer.value.addEventListener('targetAchieved', (e) => {
        callObject.value.stopRecording()
    })
    timer.value.addEventListener('reset', (e) => {
        timer.value.stop()
        timeRecorded.value = '00:00.0'
    })
}

const stopTimer = () => {
    timer.value.stop()
}

const resetTimer = () => {
    timer.value.reset()
    timer.value.removeAllEventListeners('secondsUpdated')
    timer.value.removeAllEventListeners('targetAchieved')
}

</script>